import React from 'react';

import StandardModal from '@/components/commons/StandardModal';
import Button, { ButtonSize, ButtonType } from '@/components/commons/button';

import styles from './ActionModal.module.css';

// we're using any here to avoid a proptype error!
// it should be deleted as soon as we fully embrace typescript
interface ConfirmActionModalTypes {
    readonly closeModal: () => void,
    readonly display: boolean,
    readonly onSubmit: () => void,
    readonly actionType: string;
}

function ConfirmActionModal({
    closeModal,
    display,
    onSubmit,
    actionType,
}: ConfirmActionModalTypes) {
    return (
        <StandardModal
            open={display}
            onClose={closeModal}
            data-testid="modal-confirmActionModal"
            classNames={{
                modal: 'p-4 sm:p-10 max-w-none max-h-[90vh]',
            }}
            headline="Confirm Your Action"
        >
            <div className="flex flex-col justify-center items-center">
                <h3 className={styles.modalHeader}>
                    This action will affect the selected rules.
                </h3>

                <p className="mt-4">
                    The selected rules will be
                    {' '}
                    <span className="font-bold">{`"${actionType}d"`}</span>
                </p>

                <div className={styles.actionsContainer}>
                    <Button
                        externalStyles="mx-auto w-full sm:w-[140px] block border-gray-300 border-y border-x  h-10 py-0 px-0"
                        size={ButtonSize.base}
                        text="Yes, continue"
                        type={ButtonType.submit}
                        onClick={onSubmit}
                    />
                    <Button
                        externalStyles="mx-auto block text-cleanSlate border-gray-300 border-y border-x w-full sm:w-[120px] h-10 bg-cirrusWhite my-4 sm:my-0 py-0 px-0 "
                        size={ButtonSize.base}
                        text="Cancel"
                        onClick={closeModal}
                    />
                </div>
            </div>

        </StandardModal>
    );
}

export default ConfirmActionModal;
